module.exports = __webpack_public_path__ + "img/background.48dd65ca.png";